import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../services';

@Component({
  selector: 'bc-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss']
})
export class ContactDetailsComponent implements OnInit {
  contacts: ContactDetails;

  constructor(private settingsService: SettingsService) { }

  ngOnInit() {
    this.getContactSettings();
  }

  getContactSettings(): any {
    this.settingsService.resolve()
    .then((response: Settings) => {
      if (response.contactDetails) {
        this.contacts = response.contactDetails;
      }
    });
  }

  isEnabled = (field) => this.contacts && this.contacts[field].enabled;
}
